var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgUserrole = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2.5C11.7259 2.5 13.125 3.89911 13.125 5.625C13.125 7.35089 11.7259 8.75 10 8.75C8.27411 8.75 6.875 7.35089 6.875 5.625C6.875 3.89911 8.27411 2.5 10 2.5ZM10 1.25C7.58375 1.25 5.625 3.20875 5.625 5.625C5.625 8.04125 7.58375 10 10 10C12.4162 10 14.375 8.04125 14.375 5.625C14.375 3.20875 12.4162 1.25 10 1.25ZM16.25 18.75H15V15.625C15 14.7962 14.6708 14.0013 14.0847 13.4153C13.4987 12.8292 12.7038 12.5 11.875 12.5H8.125C6.39911 12.5 5 13.8991 5 15.625V18.75H3.75V15.625C3.75 13.2088 5.70875 11.25 8.125 11.25H11.875C14.2912 11.25 16.25 13.2088 16.25 15.625V18.75Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUserrole, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/userrole.bd3368d3.svg";
export { ForwardRef as ReactComponent };